import React from 'react';
import styles from './styles.module.scss';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  padded?: boolean;
  noShadow?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  header,
  footer,
  padded = true,
  noShadow = false,
  onClick,
  style
}) => {
  const cardClasses = [
    styles.card,
    noShadow ? styles.noShadow : '',
    onClick ? styles.clickable : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div
      className={cardClasses}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={style}
    >
      {header && (
        <div className={styles.header}>
          {header}
        </div>
      )}

      <div className={padded ? styles.padded : styles.body}>
        {children}
      </div>

      {footer && (
        <div className={styles.footer}>
          {footer}
        </div>
      )}
    </div>
  );
};

interface CardHeaderProps {
  children?: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  className = '',
  title,
  action
}) => {
  if (title || action) {
    return (
      <div className={`${styles.headerWithAction} ${className}`}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {children}
        {action && <div>{action}</div>}
      </div>
    );
  }

  return <div className={className}>{children}</div>;
};

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
  small?: boolean;
}

export const CardFooter: React.FC<CardFooterProps> = ({
  children,
  className = '',
  small = false
}) => {
  return (
    <div className={`${small ? styles.footerSmall : styles.footer} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
